export const cardColor = {

    backgroundStyleFile:{

    

        backgroundColor: '#E5E9E9',

    },
    backgroundStyleSizeFile:{

    

        backgroundColor: '#E5E9E9',
        minWidth: '100%'



    }



}


export const ColoresInstitucionales = {

    azul:{

        backgroundColor: 'rgb(37,44,95)',
      
    },
    gold:{

        backgroundColor: 'rgb(203,151,0)',
        color: 'rgb(203,151,0)',


    },
    celeste:{

        
        color: 'rgb(97,183,228)',


    },

    margin:{
        marginRight: 5
    }




}